import { reverse } from 'named-urls';
import { matchPath } from 'react-router';
import routes from './routeCodes';
routes.route = (routeName) => {
   return routes[routeName];
};


function getCompiledPath(params = {}) {
   return reverse(this.path, params);
}

function getMask() {
   return this.path;
}

function localRouteisTopLevel() {
   return !!this.topLevel;
}

function match(locationPath) {
   return matchPath(locationPath, {
      path: this.path,
      exact: this.exact,
      strict: false,
   })
}

function getParent() {
   return routes[this.parentKey];
}

function getTitle() {
   return this.title;
}

function setTitle(title) {
   this.title = title;
}

function getCancel() {
   return this.cancel;
}

function getBackSearchParams() {
   return this.backSearchParams;
}
function getBackSearchParamsTitle() {
   return this.backSearchParamsTitle;
}

function getHasBackSearchParams() {
   return !!this.hasBackSearchParams;
}

Object.getOwnPropertyNames(routes).forEach((key) => {
   routes[key].getCompiledPath = getCompiledPath;
   routes[key].getMask = getMask;
   routes[key].match = match;
   routes[key].isTopLevelRoute = localRouteisTopLevel;
   routes[key].getParent = getParent;
   routes[key].getTitle = getTitle;
   routes[key].getCancel = getCancel;
   routes[key].setTitle = setTitle;
   routes[key].getBackSearchParams = getBackSearchParams;
   routes[key].getHasBackSearchParams = getHasBackSearchParams;
   routes[key].getBackSearchParamsTitle = getBackSearchParamsTitle;
});



export function isTopLevelRoute(locationPath) {
   let isTopLevel = false;
   const route = getCurrentRoute(locationPath);
   if(route && route.match(locationPath)) {
      isTopLevel = route.isTopLevelRoute();
   }
   return isTopLevel;
}

export function getCurrentRoute(locationPath) {
   let isTopLevel = null;
   const props = Object.getOwnPropertyNames(routes);
   for(let i = 0; i < props.length; i++) {
      const route = routes[props[i]];
      if(route.match(locationPath)) {
         isTopLevel = route;
      }
   }
   return isTopLevel;
}

export default routes;
